var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,on:{"click":function($event){return _vm.clickHandler()}}},[_c('olb-icon',{attrs:{"name":'asc'}}),_vm._t("totopContent")],2)}
var staticRenderFns = []

export { render, staticRenderFns }